import { render, staticRenderFns } from "./SelectFundingScope.vue?vue&type=template&id=04ea401b&"
import script from "./SelectFundingScope.vue?vue&type=script&lang=ts&"
export * from "./SelectFundingScope.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports